export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">关于番茄视频</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">致力于打造极致高清观影体验的影视平台</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 p-8 md:p-10">
          <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed space-y-4">
            <p>
              番茄视频是一个专注于高清影视资源聚合与播放的在线平台，汇聚<strong>香蕉视频</strong>、<strong>红桃视频</strong>、<strong>蜜桃视频</strong>和<strong>91视频</strong>四大频道的海量内容，涵盖电影、电视剧、综艺、动漫等多种类型，致力于为用户提供<strong>1080P高清不缓冲</strong>的极致观影体验。
            </p>
            <p>
              我们深知追剧用户对画质和流畅度的追求，因此投入大量技术资源建设多节点CDN加速网络，确保无论您使用何种网络环境，都能享受<strong>流畅不缓冲</strong>的播放服务。同时，我们的内容团队每日精选最新最热的影视资源，热门剧集和综艺<strong>同步更新</strong>，让您第一时间看到想看的内容。
            </p>
            <p>
              从<strong>香蕉视频</strong>的院线大片到<strong>红桃视频</strong>的高分剧集，从<strong>蜜桃视频</strong>的热门综艺到<strong>91视频</strong>的经典老片，番茄视频构建了完整的影视内容矩阵，满足不同用户的多元化<strong>追剧需求</strong>。全部内容<strong>免费在线观看</strong>，无需注册登录，即点即看。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-200/60">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-600 font-heading">10万+</div>
              <div className="text-xs text-foreground-500 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-accent-600 font-heading">4大</div>
              <div className="text-xs text-foreground-500 mt-1">内容频道</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-secondary-600 font-heading">1080P</div>
              <div className="text-xs text-foreground-500 mt-1">全高清画质</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-600 font-heading">24h</div>
              <div className="text-xs text-foreground-500 mt-1">同步更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}